import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import PayPalPurchase from "apps/payment/components/PayPalPurchase";

import {
	fetchPaypalLink,
	startPurchase,
} from "ducks/payment";

export const mapStateToProps = (state) => {
	const { payment } = state;

	return payment;
};

function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			fetchPaypalLink,
			startPurchase,
		},
		dispatch,
	);
}

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(PayPalPurchase);



// WEBPACK FOOTER //
// ./src/apps/payment/containers/PayPalPurchase/index.jsx